import { TableCell } from '@material-ui/core';
import {
  APPOINTMENT_TERMINAL_RULES,
  AppointmentTerminalRuleDefinition,
} from 'pages/T_Appointments/rules';
import * as React from 'react';
import { TerminalRemote } from 'services/clients/terminal';
import { CheckSystemCell } from './CheckSystemCell';
import { LastRefreshCell } from './LastRefreshCell';
import { MessageCell } from './MessageCell';

interface Props {
  terminal: TerminalRemote;
  classes: Record<string, string>;
  lastRefreshData?: Record<
    string,
    Record<string, { last_recording_time: string; total_appointments: null | number }>
  >;
  selectedSlKey: string;
}

export const Cell: React.FC<Props> = (props) => {
  const { classes, terminal } = props;

  let inner = null;

  const rules = terminal.appointment_rules
    .map((ruleKey) => {
      return APPOINTMENT_TERMINAL_RULES[ruleKey];
    })
    .filter((rule) => !!rule) as AppointmentTerminalRuleDefinition[];

  let includeRefresh = false;
  const messages: string[] = [];
  rules.forEach((rule) => {
    messages.push(rule.header);
    includeRefresh = includeRefresh || !!rule.includeRefresh;
  });

  if (messages.length > 0) {
    inner = (
      <>
        <MessageCell classes={classes}>
          {messages.map((m) => (
            <h4 key={m}>{m}</h4>
          ))}
        </MessageCell>
        {includeRefresh ? <LastRefreshCell {...props} /> : null}
      </>
    );
  } else if (terminal && terminal.no_data_appointments) {
    inner = <CheckSystemCell terminal={terminal} classes={classes} />;
  } else {
    inner = <LastRefreshCell {...props} />;
  }

  return <TableCell className={classes.cell}>{inner}</TableCell>;
};
Cell.displayName = 'LastRefresh.Cell';
